import api from './axiosInstance';
import { setUser } from './authSlice';
import { handleErrors } from '../utils/common';

export const fetchAndSetUserProfile = () => async (dispatch) => {
    try {
        const res = await api.get('/user/profile');
        dispatch(setUser(res.data.user));
    } catch (err) {
        handleErrors(err);
    }
};